// extracted by mini-css-extract-plugin
export var avatarContainer = "_y-0";
export var avatarTypingWave = "_y-i";
export var gray = "_y-f";
export var green = "_y-c";
export var icon = "_y-9";
export var image = "_y-1";
export var lg = "_y-6";
export var md = "_y-5";
export var presenceDot = "_y-b";
export var red = "_y-d";
export var sm = "_y-4";
export var status = "_y-a";
export var typingDot = "_y-h";
export var typingPill = "_y-g";
export var xl = "_y-7";
export var xs = "_y-3";
export var xxl = "_y-8";
export var xxs = "_y-2";
export var yellow = "_y-e";